import { createAnalyticsCategories } from '@analytics/utils';
import { Injectable } from '@angular/core';
import { CustomProduct } from '@product/const';
import { AnalyticsService } from './analytics.service';
import { ProductListCartAnalyticsService } from './product-list';

@Injectable({ providedIn: 'root' })
export class CatalogAnalyticsService {
  productInListClicked: { product: CustomProduct; index: number; listName: string } | undefined = undefined;

  constructor(
    private analyticsService: AnalyticsService,
    private productListCartAnalyticsService: ProductListCartAnalyticsService,
  ) {}

  onViewProductList(products: CustomProduct[], listName: string, offset = 0): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'view_item_list',
      ecommerce: {
        items: products.map((product: CustomProduct, index: number) => {
          const categoryNamesForAnalytics = product.categoryNamesForAnalytics
            ? createAnalyticsCategories(product.categoryNamesForAnalytics)
            : {};

          return {
            item_name: product.name,
            item_id: product.code,
            price: product.price?.value,
            index: offset + index + 1,
            item_list_name: listName,
            ...categoryNamesForAnalytics,
          };
        }),
      },
    });
  }

  onClickProductInList(product: CustomProduct, listName: string, index = 0): void {
    this.productInListClicked = { product, index, listName };
    this.productListCartAnalyticsService.saveAnalyticDataForEntry({ product }, { listName, productIndex: index });
    const categoryNamesForAnalytics = product.categoryNamesForAnalytics
      ? createAnalyticsCategories(product.categoryNamesForAnalytics)
      : {};
    this.analyticsService.sendEcommerceEvent({
      event: 'select_item',
      ecommerce: {
        items: [
          {
            item_name: product.name,
            item_id: product.code,
            price: product.price?.value,
            item_list_name: listName,
            index: index + 1,
            ...categoryNamesForAnalytics,
          },
        ],
      },
    });
  }

  onAddToWishList(product: CustomProduct, listName: string): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'add_to_wishlist',
      ecommerce: {
        items: [
          {
            item_name: product.name,
            item_id: product.code,
            price: product.price.value,
            item_list_name: listName,
            index: 1,
          },
        ],
      },
    });
  }

  onViewProductPage(product: CustomProduct): void {
    // Очищаем если был переход с карточки товара на другой товар, так как нас интересует только переход из листинга
    if (this.productInListClicked && product.code !== this.productInListClicked.product.code) {
      this.clearProductInListClicked();
    }
    const categoryNamesForAnalytics = product.categoryNamesForAnalytics
      ? createAnalyticsCategories(product.categoryNamesForAnalytics)
      : {};

    this.analyticsService.sendEcommerceEvent({
      event: 'view_item',
      ecommerce: {
        items: [
          {
            item_name: product.name,
            item_id: product.code,
            price: product.price?.value,
            item_list_name: this.productInListClicked?.listName,
            index: this.productInListClicked ? this.productInListClicked.index + 1 : undefined,
            ...categoryNamesForAnalytics,
          },
        ],
      },
    });
  }

  private clearProductInListClicked(): void {
    this.productInListClicked = undefined;
  }
}
